<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="row mt-2">
                <ng-container>
                    <div class="col-md-12 d-flex justify-content-start gap-2 mb-4">
                        <button class="action-btn action-btn-create" role="button" (click)="onOpenModelAddActivity()" *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_ADD']">
                            <i-feather name="plus" class="feather-base"></i-feather>
                            {{ 'ADD_ACTIVITY' | translate }}
                        </button>
                        <button class="action-btn action-btn-edit" role="button" (click)="onOpenActivityGrid()" *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_ADD'] || auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EDIT']">
                            <i-feather name="edit-3" class="feather-base"></i-feather>
                            {{ 'BULK_EDIT_ACTIVITY' | translate }}
                        </button>
                        <button class="action-btn action-btn-export" role="button"
                            (click)="onClickExport()"
                            [disabled]="!paramForm.get('academic_year')?.value || loading.export"
                            *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EXPORT_TO_EXCEL']">
                            <ng-container *ngIf="!loading.export">
                                <i-feather name="download" class="feather-base"></i-feather>
                                {{ 'EXPORT_TO_EXCEL' | translate }}
                            </ng-container>
                            <ng-container *ngIf="loading.export">
                                <i class="fa fa-spinner fa-spin"></i>
                            </ng-container>
                        </button>
                    </div>
                </ng-container>
            </div>
            <div class="form-group row mb-3">
                <div class="col-md-3">
                    <app-select-academic-year-only
                    (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                            [academic_year]="this.paramForm.get('academic_year')?.value"
                            (schoolLevelRelationChanged)="onChangeSchoolLevel($event)">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-3">
                    <app-select-school-program
                    [academic_year]="this.paramForm.get('academic_year')?.value"
                    [school_location_id]="this.paramForm.get('school_location_id')?.value"
                    (schoolProgramChanged)="onChangeSchoolProgram($event)">
                    </app-select-school-program>
                </div>
                <div class="col-md-3">
                    <app-select-school-program-category
                    [school_program_id]="this.paramForm.get('school_program_id')?.value"
                    [all]="true"
                    (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event)">
                    </app-select-school-program-category>
                </div>
            </div>
            <div *ngIf="loading.list" class="d-flex justify-content-center align-items-center" style="margin-top:70px">
                <mat-spinner></mat-spinner>
            </div>
            <!-- <div *ngIf="schoolActivities.length === 0 && !loading.list && checkedActivity"> -->
            <div *ngIf="!paramForm.get('school_location_id')?.value && !loading.list">
                <span style="font-size: 14px; color: #a3453b;"><i>Please select the parameters!</i></span>
            </div>

            <div *ngIf="paramForm.get('school_location_id')?.value && !loading.list" class="table-responsive">
                <app-status-no-data [show]="schoolActivities.length === 0"></app-status-no-data>

                <table mat-table *ngIf="schoolActivities.length > 0 && !loading.list"
                       [dataSource]="schoolActivities" multiTemplateDataRows>
                    <colgroup>
                        <col style="width: 20%;">
                        <col style="width: 25%;">
                        <col style="width: 15%;">
                        <col style="width: 15%;">
                        <col style="width: 25%;" *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EDIT'] || auth.permissions['SCHOOL_PROGRAM_ACTIVITY_DELETE']">
                    </colgroup>
                    <ng-container matColumnDef="activity_name">
                        <th mat-header-cell *matHeaderCellDef (click)="onSort('activity_name')" class="cursor-pointer"> {{ 'ACTIVITY_NAME' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.activity_name}} <i *ngIf="element.gender === 'M'" class="fa-solid fa-mars" style="color: #1db0ff;"></i><i *ngIf="element.gender === 'F'" class="fa-solid fa-venus" style="color: #ff69b4;"></i>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activity_description">
                        <th mat-header-cell *matHeaderCellDef> {{ 'ACTIVITY_DESCRIPTION' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-name">
                            {{element.activity_description}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="participants_1">
                        <th mat-header-cell *matHeaderCellDef> {{ 'PARTICIPANT_ODD' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-name" [class.clickable-cell]="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_VIEW']" (click)="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_VIEW'] && onOpenParticipantList(element, 1)">
                            <div class="slot-progress" [ngClass]="slotClass(element.participant_count_Ganjil, element.max_participant)">
                                <span class="slot-label">{{ element.participant_count_Ganjil || 0 }}/{{ element.max_participant }}</span>
                                <span class="slot-track">
                                    <span class="slot-fill" [style.width.%]="slotPercent(element.participant_count_Ganjil, element.max_participant)"></span>
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="participants_2">
                        <th mat-header-cell *matHeaderCellDef> {{ 'PARTICIPANT_EVEN' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-name" [class.clickable-cell]="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_VIEW']" (click)="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_VIEW'] && onOpenParticipantList(element, 2)">
                            <div class="slot-progress" [ngClass]="slotClass(element.participant_count_Genap, element.max_participant)">
                                <span class="slot-label">{{ element.participant_count_Genap || 0 }}/{{ element.max_participant }}</span>
                                <span class="slot-track">
                                    <span class="slot-fill" [style.width.%]="slotPercent(element.participant_count_Genap, element.max_participant)"></span>
                                </span>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action" *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EDIT'] || auth.permissions['SCHOOL_PROGRAM_ACTIVITY_DELETE']">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center"> {{ 'ACTIONS' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <div class="d-flex justify-content-center gap-2" *ngIf="element.approved">
                                <button class="action-icon-btn action-icon-edit"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EDIT']"
                                    (click)="editActivity(element.school_program_activity_id)"
                                    [title]="'EDIT_ACTIVITY' | translate">
                                    <div>
                                        <i-feather name="edit-2" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button class="action-icon-btn action-icon-pdf"
                                    [disabled]="loadingAll.export_pdf"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EXPORT_PDF']"
                                    (click)="onExportToPdf(element.school_program_activity_id)"
                                    [title]="'EXPORT_PDF' | translate">
                                    <div>
                                        <i-feather name="file-text" class="feather-base"></i-feather>
                                    </div>
                                </button>
                                <button class="action-icon-btn action-icon-delete"
                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_DELETE']"
                                    (click)="deleteActivity(element)"
                                    [title]="'REMOVE' | translate">
                                    <div>
                                        <i-feather name="trash-2" class="feather-base"></i-feather>
                                    </div>
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
                <mat-paginator *ngIf="schoolActivities.length > 0"
                    [pageSize]="15"
                    (page)="onChangePage($event)"
                    [pageIndex]="currentPage - 1"
                    [length]="total">
                </mat-paginator>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #viewActivity let-modal let-close="close">
    <div class="modal-header">
        <div class="row">
            <div class="col-md-12">
                <h5 class="modal-title">{{ 'MANAGE_PARTICIPANT' | translate }}</h5>
            </div>
        </div>
    </div>

    <ng-container>
        <form [formGroup]="editActivityForm">
        <div class="modal-body d-grid">
            <app-status-loading [show]="loading.detail"></app-status-loading>
            <div class="row float-start mb-2 d-grid col-md-12"  *ngIf="!loading.detail">
                <div class="d-grid mb-2">
                    <span style="font-size: 22px; font-weight: 600; color: #1F1F1F; letter-spacing: -0.01em;">{{ 'ACTIVITY_NAME' | translate }} : {{ detailData.activity.activity_name }}</span>
                </div>
            </div>
            <div class="mt-4">
                <span style="font-size: 14px; font-weight: 600; color: #1F1F1F;">{{ 'Manage Participant' | translate }}</span>
            </div>
            <div>
                <span *ngIf="disabledEditParticipant" style="font-size: 12px; color: #a3453b;">*you are not be able to add/remove participant because activity registration period is open</span>
            </div>
            <div *ngIf="!loading.detail" class="p-2">
                <mat-slide-toggle (toggleChange)="onToggle()"
                        class="example-margin"
                        [color]="color"
                        [checked]="toggle">
                    {{ 'ALL_PERIOD' | translate }}
                </mat-slide-toggle>
            </div>
            <mat-tab-group *ngIf="!loading.detail" class="p-2">
                <mat-tab label="{{ 'GANJIL' | translate }}" [disabled]="toggle">
                    <div class="mt-4">
                        <span class="fw-bold">{{ 'REGISTERED_STUDENT' | translate }}:</span>
                    </div>
                    <div class="mb-2 mt-4">
                        <input type="text" class="form-control" placeholder="{{ 'SEARCH_STUDENT' | translate }}" [(ngModel)]="searchFilterRegistered" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchFilterRegistered()" />
                    </div>
                    <div class="table-responsive table-list-wrapper table-fixed" *ngIf="participantDataGanjil && participantDataGanjil.length > 0">
                        <table class="table table-list">
                            <thead style="font-size: 12px">
                            <tr>
                                <th>No</th>
                                <th>{{ 'STUDENT_ID' | translate }}</th>
                                <th>{{ 'CLASS_NAME' | translate }}</th>
                                <th>{{ 'STUDENT_NAME' | translate }}</th>
                                <th>{{ 'STATUS' | translate }}</th>
                                <th *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] && !disabledEditParticipant">{{ 'ACTION' | translate }}</th>
                            </tr>
                            </thead>
                            <tbody style="font-size: 12px">
                            <tr *ngFor="let item of participantDataGanjil; let i = index;" class="col-md-12">
                                <td class="text-center col-md-1">{{ (i + 1) }}</td>
                                <td class="text-center col-md-2">{{ item.nis }}</td>
                                <td class="text-center col-md-2">{{ item.class_name }}</td>
                                <td class="text-center col-md-5">{{ item.student_name }}</td>
                                <td class="text-center col-md-2">
                                    <span *ngIf="item.activity_participant_id" class="badge bg-success">{{ 'PAID' | translate }}</span>
                                    <span *ngIf="!item.activity_participant_id" class="badge bg-danger">{{ 'UNPAID' | translate }}</span>
                                </td>
                                <td class="text-center col-md-3" *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] && !disabledEditParticipant">
                                    <span class="link text-danger font-weight-bold mx-1 cursor-pointer" (click)="onRemove(item.activity_participant_id)">{{isDelete(item.activity_participant_id) ? "Selected" : ('REMOVE' | translate)}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <app-status-no-data [show]="!participantDataGanjil && !loading.student"></app-status-no-data>
                        <app-status-loading [show]="!participantDataGanjil && loading.student"></app-status-loading>
                    </div>
                    <div class="mt-4">
                        <span class="fw-bold">{{ 'UNREGISTERED_STUDENT' | translate }}:</span>
                    </div>
                    <div class="mb-2 mt-4">
                        <input type="text" class="form-control" placeholder="{{ 'SEARCH_STUDENT' | translate }}" [(ngModel)]="searchFilterUnregistered" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchFilterUnregistered()" />
                    </div>
                    <div class="table-responsive table-list-wrapper table-fixed" *ngIf="unRegisteredStudentGanjil && unRegisteredStudentGanjil.length > 0">
                        <table class="table table-list">
                            <thead style="font-size: 12px">
                            <tr>
                                <th *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']">
                                    <!-- Check All -->
                                    <app-input-checkbox [name]="'is_block_all_ganjil'"
                                        [isChecked]="isCheckAllGanjil()"
                                        (onChecked)="onCheckAllGanjil()">
                                    </app-input-checkbox>
                                </th>
                                <th>{{ 'STUDENT_ID' | translate }}</th>
                                <th>{{ 'CLASS_NAME' | translate }}</th>
                                <th>{{ 'STUDENT_NAME' | translate }}</th>
                                <th>{{ 'TOTAL_ACTIVITY_PARTICIPATED' | translate }}</th>
                            </tr>
                            </thead>
                            <tbody style="font-size: 12px">
                            <tr *ngFor="let item of unRegisteredStudentGanjil; let i = index;" class="col-md-12">
                                <td *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']" class="col-md-1"> <app-input-checkbox
                                        [name]="'is_block-' + i"
                                        [isChecked]="isChecked(item.student_id)"
                                        (onChecked)="onChecked(item.student_id)">
                                </app-input-checkbox>
                                </td>
                                <td class="text-center col-md-2">{{ item.nis }}</td>
                                <td class="text-center col-md-2">{{ item.class_name }}</td>
                                <td class="text-center col-md-5">{{ item.student_name }}</td>
                                <td class="text-center col-md-3">
                                    0
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <app-status-no-data [show]="!unRegisteredStudentGanjil && !loading.unRegis"></app-status-no-data>
                        <app-status-loading [show]="!unRegisteredStudentGanjil && loading.unRegis"></app-status-loading>
                    </div>
                </mat-tab>
                <mat-tab label="{{ 'GENAP' | translate }}" [disabled]="toggle">
                    <div class="mt-1">
                        <span class="fw-bold">{{ 'REGISTERED_STUDENT' | translate }}:</span>
                    </div>
                    <div class="mb-2 mt-4">
                        <input type="text" class="form-control" placeholder="{{ 'SEARCH_STUDENT' | translate }}" [(ngModel)]="searchFilterRegistered" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchFilterRegistered()" />
                    </div>
                    <div class="table-responsive table-list-wrapper table-fixed" *ngIf="participantDataGenap && participantDataGenap.length > 0">
                        <table class="table table-list">
                            <thead style="font-size: 12px">
                            <tr>
                                <th>No</th>
                                <th>{{ 'STUDENT_ID' | translate }}</th>
                                <th>{{ 'CLASS_NAME' | translate }}</th>
                                <th>{{ 'STUDENT_NAME' | translate }}</th>
                                <th *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] && !disabledEditParticipant">{{ 'ACTION' | translate }}</th>
                            </tr>
                            </thead>
                            <tbody style="font-size: 12px">
                            <tr *ngFor="let item of participantDataGenap; let i = index;" class="col-md-12">
                                <td class="text-center col-md-1">{{ (i + 1) }}</td>
                                <td class="text-center col-md-2">{{ item.nis }}</td>
                                <td class="text-center col-md-2">{{ item.class_name }}</td>
                                <td class="text-center col-md-5">{{ item.student_name }}</td>
                                <td class="text-center col-md-3" *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] && !disabledEditParticipant">
                                    <span class="link text-danger font-weight-bold mx-1 cursor-pointer" (click)="onRemoveGenap(item.activity_participant_id)">{{isDeleteGenap(item.activity_participant_id) ? "Selected" : ('REMOVE' | translate)}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <app-status-no-data [show]="!participantDataGenap && !loading.student"></app-status-no-data>
                        <app-status-loading [show]="!participantDataGenap && loading.student"></app-status-loading>
                    </div>
                    <div class="mb-2 mt-4">
                        <span class="fw-bold">{{ 'UNREGISTERED_STUDENT' | translate }}:</span>
                    </div>
                    <div class="mb-2 mt-4">
                        <input type="text" class="form-control" placeholder="{{ 'SEARCH_STUDENT' | translate }}" [(ngModel)]="searchFilterUnregistered" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSearchFilterUnregistered()" />
                    </div>
                    <div class="table-responsive table-list-wrapper table-fixed" *ngIf="unRegisteredStudentGenap && unRegisteredStudentGenap.length > 0">
                        <table class="table table-list">
                            <thead style="font-size: 12px">
                            <tr>
                                <th *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']">
                                    <!-- Check All -->
                                    <app-input-checkbox [name]="'is_block_all_genap'"
                                        [isChecked]="isCheckAllGenap()"
                                        (onChecked)="onCheckAllGenap()">
                                    </app-input-checkbox>
                                </th>
                                <th>{{ 'STUDENT_ID' | translate }}</th>
                                <th>{{ 'CLASS_NAME' | translate }}</th>
                                <th>{{ 'STUDENT_NAME' | translate }}</th>
                                <th>{{ 'TOTAL_ACTIVITY_PARTICIPATED' | translate }}</th>
                            </tr>
                            </thead>
                            <tbody style="font-size: 12px">
                            <tr *ngFor="let item of unRegisteredStudentGenap; let i = index;" class="col-md-12">
                                <td *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD']" class="col-md-1"> <app-input-checkbox
                                        [name]="'is_block-' + i"
                                        [isChecked]="isCheckedGenap(item.student_id)"
                                        (onChecked)="onCheckedGenap(item.student_id)">
                                </app-input-checkbox>
                                </td>
                                <td class="text-center col-md-2">{{ item.nis }}</td>
                                <td class="text-center col-md-2">{{ item.class_name }}</td>
                                <td class="text-center col-md-5">{{ item.student_name }}</td>
                                <td class="text-center col-md-3">
                                    0
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <app-status-no-data [show]="!unRegisteredStudentGenap && !loading.unRegis"></app-status-no-data>
                        <app-status-loading [show]="!unRegisteredStudentGenap && loading.unRegis"></app-status-loading>
                    </div>
                </mat-tab>
            </mat-tab-group>
            <div class="col-md-12 d-flex mb-2 mt-4 justify-content-between" *ngIf="!loading.detail">
                <button class="gradient-button col-md-2 me-1" role="button" (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
                <button class="gradient-button col-md-2 me-1" role="button" (click)="onSaveDetail()" *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD'] || auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE']">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
        </form>
    </ng-container>
</ng-template>

<ng-template #participantListModal let-modal let-close="close">
    <div class="modal-header">
        <div class="row">
            <div class="col-md-12">
                <h5 class="modal-title">{{ 'PARTICIPANT_REGISTRANT_LIST' | translate }}</h5>
            </div>
        </div>
    </div>
    <div class="modal-body d-grid">
        <app-status-loading [show]="loading.participantList"></app-status-loading>
        <div class="row float-start mb-2 d-grid col-md-12" *ngIf="!loading.participantList">
            <div class="d-grid mb-2">
                <span style="font-size: 18px; font-weight: 600; color: #1F1F1F;">{{ 'ACTIVITY_NAME' | translate }} : {{ participantListActivityName }} - {{ (participantListPeriod === 1 ? 'GANJIL' : 'GENAP') | translate }}</span>
            </div>
        </div>
        <mat-tab-group *ngIf="!loading.participantList" class="p-2">
            <mat-tab label="{{ 'PARTICIPANT' | translate }} ({{ participantOnlyList.length }})">
                <div class="table-responsive table-list-wrapper table-fixed mt-3" *ngIf="participantOnlyList.length > 0">
                    <table class="table table-list">
                        <thead style="font-size: 12px">
                        <tr>
                            <th>No</th>
                            <th>{{ 'STUDENT_NAME' | translate }}</th>
                            <th>{{ 'STUDENT_ID' | translate }}</th>
                            <th>{{ 'CLASS_NAME' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody style="font-size: 12px">
                        <tr *ngFor="let item of participantOnlyList; let i = index;">
                            <td class="text-center">{{ (i + 1) }}</td>
                            <td class="text-center">{{ item.student_name }}</td>
                            <td class="text-center">{{ item.nis }}</td>
                            <td class="text-center">{{ item.class_name }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <app-status-no-data [show]="participantOnlyList.length === 0"></app-status-no-data>
            </mat-tab>
            <mat-tab label="{{ 'REGISTRANT' | translate }} ({{ registrantOnlyList.length }})">
                <div class="table-responsive table-list-wrapper table-fixed mt-3" *ngIf="registrantOnlyList.length > 0">
                    <table class="table table-list">
                        <thead style="font-size: 12px">
                        <tr>
                            <th>No</th>
                            <th>{{ 'STUDENT_NAME' | translate }}</th>
                            <th>{{ 'STUDENT_ID' | translate }}</th>
                            <th>{{ 'CLASS_NAME' | translate }}</th>
                        </tr>
                        </thead>
                        <tbody style="font-size: 12px">
                        <tr *ngFor="let item of registrantOnlyList; let i = index;">
                            <td class="text-center">{{ (i + 1) }}</td>
                            <td class="text-center">{{ item.student_name }}</td>
                            <td class="text-center">{{ item.nis }}</td>
                            <td class="text-center">{{ item.class_name }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <app-status-no-data [show]="registrantOnlyList.length === 0"></app-status-no-data>
            </mat-tab>
        </mat-tab-group>
        <div class="col-md-12 d-flex mb-2 mt-4 justify-content-end" *ngIf="!loading.participantList">
            <button class="gradient-button col-md-2 me-1" role="button" (click)="modalService.dismissAll()">{{ 'CANCEL' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #modalExport let-modal let-close="close">
    <div class="modal-header mb-4">
        <div class="row">
            <div class="col-md-12">
                <h5 class="modal-title">{{ 'SELECT COLUMN TO EXPORT' | translate }}</h5>
            </div>
        </div>
    </div>
    <div class="mb-4 col-12">
        <div class="row">
            <div *ngFor="let column of allColumn" class="col-md-6">
                <div class="d-flex p-1">
                    <div class="me-2">
                        <input
                            [checked]="column.check"
                            (change)="onChangeColumn(column)"
                            id="{{ column.name }}"
                            type="checkbox"
                        />
                    </div>
                    <div>{{ column.name }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-4 col-md-12">
        <button class="gradient-button col-md-2 me-1" role="button"
            (click)="onExportToExcel()"
            [disabled]="!paramForm.get('academic_year')?.value || loading.export"
            *ngIf="auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EXPORT_TO_EXCEL']">
            <ng-container *ngIf="!loading.export">
                {{ 'EXPORT_TO_EXCEL' | translate }}
            </ng-container>
            <ng-container *ngIf="loading.export">
                <i class="fa fa-spinner fa-spin"></i>
            </ng-container>
        </button>
    </div>
</ng-template>
